import { Button, ButtonGroup, InputPicker, Modal, Panel, Placeholder, SelectPicker, Stack } from "rsuite";
import PlusIcon from '@rsuite/icons/Plus';
import axios from "axios";

import { getCookies } from "cookies-next";
import { config } from "../../data/config";
import { useState, useEffect } from "react";
import * as React from 'react';
import TissText from './TissText';
import TissImage from './TissImage';
import TissHeading from './TissHeading';
import { useTranslation } from 'react-i18next';
import ArrowUpLineIcon from '@rsuite/icons/ArrowUpLine';
import ArrowDownLineIcon from '@rsuite/icons/ArrowDownLine';
import TrashIcon from '@rsuite/icons/Trash';
import AddOutlineIcon from '@rsuite/icons/AddOutline';


import TissMovie from './TissMovie';
import TissCatalog from "./TissCatalog";
import TissSlider from "./TissSlider";
import TissGallery from "./TissGallery";
import TissList from "./TissList";
import TissTable from "./TissTable";
import TissChart from "./TissChart";
export default function TissEditor({ component, parent }: any) {
    const { t } = useTranslation();
    const [data, setData] = React.useState<any[]>([]);
    const [open, setOpen] = React.useState(false);
    const [id, setId] = React.useState(false);

    let cookie = getCookies();
    const [backdrop, setBackdrop] = React.useState('static');
    const addContainer = async (mode: any) => {
        try {
            var path = `${config.url}/v1/dashboard/container`;

            let res = await axios({
                method: 'post',
                url: path,
                data: {
                    parent: parent,
                    component: component,
                    mode: mode
                },
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            loaditem();
            //    setData(res.data.message)
        } catch (error) {


        }
    }
    const removeContainer = async (id: any) => {
        try {
            var path = `${config.url}/v1/dashboard/container/${id}`;

            let res = await axios({
                method: 'delete',
                url: path,
               
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            loaditem();
            //    setData(res.data.message)
        } catch (error) {


        }
    }
    const updateItemComponent = async (col: any, id: any) => {

        try {
            var x = 3;

            var path = `${config.url}/v1/dashboard/container/colsupdate/${id}`;
            await axios({
                method: 'post',
                url: path,
                data: {
                    cols: col
                },
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            loaditem();
        } catch (error) {

        }
    }
    const loaditem = async () => {
        try {
            var path = `${config.url}/v1/dashboard/container/getlist/${parent}`;

            let res = await axios({
                method: 'get',
                url: path,

                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });

            setData(res.data.message)
        } catch (error) {


        }
    }

    const deleteitem = async (id: any) => {
        try {

            var path = `${config.url}/v1/dashboard/component/${id}`;
            await axios({
                method: 'delete',
                url: path,

                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            loaditem();
        } catch (error) {

        }
    }
    const Gridoption = (i: any) => {

        switch (i) {
            case 3:
                var x = 'sm:col-span-4 col-span-12';
                break;
            case 2:
                var x = 'sm:col-span-6 col-span-12';
                break;
            case 1:
                var x = 'sm:col-span-12 col-span-12';
                break;
            default:
                var x = 'sm:col-span-12 col-span-12';
        }

        return x;

    }
    const arrowupContainer = async (id: any) => {
        try {

            var path = `${config.url}/v1/dashboard/container/arrowup/${id}`;
            await axios({
                method: 'post',
                url: path,

                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            loaditem();
        } catch (error) {

        }
    }
    const arrowup = async (id: any) => {
        try {

            var path = `${config.url}/v1/dashboard/component/arrowup/${id}`;
            await axios({
                method: 'post',
                url: path,

                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            loaditem();
        } catch (error) {

        }
    }
    const arrowdown = async (id: any) => {
        try {

            var path = `${config.url}/v1/dashboard/component/arrowdown/${id}`;
            await axios({
                method: 'post',
                url: path,

                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            loaditem();
        } catch (error) {

        }
    }
    const arrowdownContainer = async (id: any) => {
        try {

            var path = `${config.url}/v1/dashboard/container/arrowdown/${id}`;
            await axios({
                method: 'post',
                url: path,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            loaditem();
        } catch (error) {

        }
    }
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const sizes = [
        { value: 1, label: '1/1' },
        { value: 2, label: '1/2' },
        { value: 3, label: '1/3' }
    ].map(item => ({ label: item.label, value: item.value }));
    useEffect(() => {
        loaditem();
    }, []);
    return (
        <div>
            <Modal keyboard={false} open={open} onClose={handleClose}>
                <Modal.Header>
                    <Modal.Title>
                        <div style={{ fontSize: '12px' }}>
                            انتخاب کامپوننت
                        </div>
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <SelectTools component={component} loaditem={loaditem} parent={id}></SelectTools>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={handleClose} appearance="primary">
                        بستن
                    </Button>

                </Modal.Footer>
            </Modal>
            <div className="w-full">
                <div className="grid grid-cols-12 justify-between gap-3 " dir="ltr">
                    {
                        data.map((item: any) => {
                            return (
                                <div className={` ${Gridoption(item.cols)} `}>
                                    <Panel
                                        bordered
                                        header={
                                            <Stack justifyContent="space-between">
                                                <ButtonGroup>
                                                    <Button onClick={(e) => { arrowupContainer(item.id); }} >
                                                        <ArrowUpLineIcon></ArrowUpLineIcon>
                                                    </Button>

                                                    <Button onClick={(e) => { arrowdownContainer(item.id); }} >
                                                        <ArrowDownLineIcon></ArrowDownLineIcon>
                                                    </Button>
                                                    <Button
                                                        onClick={(e) => {
                                                            removeContainer(item.id);
                                                        }}
                                                    >
                                                        <TrashIcon></TrashIcon>
                                                    </Button>
                                                    <Button onClick={(e) => {
                                                        setId(item.id);
                                                        handleOpen()
                                                    }}>
                                                        <AddOutlineIcon></AddOutlineIcon>
                                                    </Button>

                                                </ButtonGroup>
                                                <InputPicker
                                                    onChange={(e) => {
                                                        updateItemComponent(e, item.id);
                                                    }}
                                                    size={`sm`}
                                                    data={sizes} style={{ width: 100 }} />
                                            </Stack>
                                        }
                                    >
                                        {
                                            item.toCompoennt.lenght != 0 ? item.toCompoennt.map((p: any) => {
                                                return (
                                                    <div className={`flex flex-col gap-3 p-3  rounded `}>
                                                        <div className={`border-[1px]   `}>
                                                            <Stack justifyContent="space-between">
                                                                <ButtonGroup >
                                                                    <Button color={`orange`} onClick={(e) => { arrowup(p.id); }} >
                                                                        <ArrowUpLineIcon></ArrowUpLineIcon>
                                                                    </Button>

                                                                    <Button onClick={(e) => { arrowdown(p.id); }} >
                                                                        <ArrowDownLineIcon></ArrowDownLineIcon>
                                                                    </Button>
                                                                    <Button onClick={(e) => { deleteitem(p.id); }} >
                                                                        <TrashIcon></TrashIcon>
                                                                    </Button>
                                                                </ButtonGroup>
                                                            </Stack>
                                                            <div>
                                                                {p.mode}
                                                            </div>
                                                            <ChoiceCom data={p} loaditem={loaditem} componentname={p.mode}></ChoiceCom>

                                                        </div>
                                                    </div>
                                                )
                                            })
                                                : <Placeholder.Grid rows={5} />}

                                    </Panel>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
            <div>
                <Button className="w-full" size={`lg`} onClick={(e) => { addContainer('container') }}>
                    <PlusIcon></PlusIcon>
                </Button>
            </div>
        </div>
    )
}

function SelectTools({ component, loaditem, parent }: any) {
    const { t } = useTranslation();

    const boxeditor = {
        editorbutton: "border border-dashed pt-2 pb-2 border-gray-400 rounded flex flex-col gap-2   cursor-pointer p-1  hover:bg-sky-100 text-center",
        captiontext: "text-[12px] text-center",
        imagebtn: "m-auto w-[20px]"
    }
    let cookie = getCookies();

    const saveitem = async (mode: any) => {
        try {
            var path = `${config.url}/v1/dashboard/component`;

            let res = await axios({
                method: 'post',
                url: path,
                data: {
                    parent: parent,
                    component: 'container',
                    mode: mode
                },
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            loaditem();
            //    setData(res.data.message)
        } catch (error) {

        }
    }
    let listofcomponnent = [
        { mode: 'text', icon: '/Editor/text.svg', label: t('Text') },
        { mode: 'heading', icon: '/Editor/h1.svg', label: t('Heading') },
        { mode: 'image', icon: '/Editor/image.svg', label: t('Image') },
        { mode: 'movie', icon: '/Editor/movie.svg', label: t('فیلم') },
        { mode: 'catalog', icon: '/Editor/files.svg', label: t('فایل , کاتالوگ') },
        { mode: 'slider', icon: '/Editor/slider.svg', label: t('اسلایدر') },
        { mode: 'gallery', icon: '/Editor/gallery.svg', label: t('گالری') },
        { mode: 'product', icon: '/Editor/product.svg', label: t('محصول') },
        { mode: 'list', icon: '/Editor/list.svg', label: t('لیست') },
        { mode: 'table', icon: '/Editor/table.svg', label: t('جدول') },
        { mode: 'map', icon: '/Editor/map.svg', label: t('نقشه') },
        { mode: 'chart', icon: '/Editor/chart.svg', label: t('چارت') },


    ]
    return (
        <>
            <div className="col-span-2 gap-4 p-4">
                <div className="grid grid-cols-5 gap-3 mb-3">
                    {
                        listofcomponnent.map((item: any) => {
                            return (
                                <div className={boxeditor.editorbutton} onClick={(e) => {
                                    saveitem(item.mode);
                                }}>
                                    <img src={item.icon} className={boxeditor.imagebtn} width={'70%'}></img>
                                    <div className={boxeditor.captiontext}
                                    > {item.label}</div>
                                </div>
                            )
                        })
                    }

                    <div className={boxeditor.editorbutton}

                        onClick={(e) => {
                            saveitem('chart');
                        }}

                    >
                        <img src="/Editor/chart.svg" className={boxeditor.imagebtn} width={'70%'}></img>
                        <div className={boxeditor.captiontext} > چارت</div>
                    </div>

                </div>

            </div>
        </>
    )
}

function ChoiceCom({ data, loaditem, componentname }: any) {

    switch (componentname) {
        case 'text':
            return <TissText data={data} reload={loaditem}></TissText>;
            break;
        case 'heading':
            return <TissHeading data={data} reload={loaditem}></TissHeading>;
            break;
        case 'image':
            return <TissImage data={data} reload={loaditem}></TissImage>;
            break;
        case 'movie':
            return <TissMovie data={data} reload={loaditem}></TissMovie>;
        case 'catalog':
            return <TissCatalog data={data} reload={loaditem}></TissCatalog>;
        case 'slider':
            return <TissSlider data={data} reload={loaditem}></TissSlider>;
        case 'gallery':
            return <TissGallery data={data} reload={loaditem}></TissGallery>;
        case 'list':
            return <TissList data={data} reload={loaditem}></TissList>;

        case 'table':
            return <TissTable data={data} reload={loaditem}></TissTable>;
        case 'chart':
            return <TissChart data={data} reload={loaditem}></TissChart>;

            break;
        default:
            return <NoneText componentname={componentname}></NoneText>;
    }


}
function NoneText({ componentname }: any) {
    return (
        <div className="text-center p-4">
        </div>
    )
}
